import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/gossip";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <SectionHeading
              kicker="常见问题"
              title="关于「深扒复盘」你可能想问的"
              desc="我们把最常被问到的几个问题整理在这里。如果还有疑问，欢迎通过页脚邮箱联系。"
            />
          </div>

          <div className="lg:col-span-8">
            <dl className="divide-y divide-background-200 border-y border-background-200">
              {faqs.map((f, idx) => {
                const isOpen = open === idx;
                return (
                  <div key={f.q}>
                    <dt>
                      <button
                        type="button"
                        onClick={() => setOpen(isOpen ? -1 : idx)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 py-5 text-left cursor-pointer"
                      >
                        <span className="font-heading font-semibold text-[15px] md:text-base text-foreground-950">
                          {f.q}
                        </span>
                        <span
                          className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-md transition-colors ${
                            isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                          }`}
                        >
                          <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`}></i>
                        </span>
                      </button>
                    </dt>
                    {isOpen && (
                      <dd className="pb-5 pr-10 font-label text-sm leading-relaxed text-foreground-600">
                        {f.a}
                      </dd>
                    )}
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}